import { useCallback } from 'react'
import { Query } from 'types'
import { identity } from 'utils'
import { useRequest } from '../useRequest'
import { useServiceCountryUrl } from '../useServiceCountryUrl'
import { stripScoringPii, type GetAppointmentScoringsResponse } from './stripScoringPii'
import type { AppointmentScoringRecord, AppointmentScoringStatus, ScoringCategoryKey } from './types'
import { PAYMENT_NOT_ASSESSABLE, SCORING_CATEGORY_MAX, SCORING_CATEGORY_ORDER } from './types'

const apiVersionSuffix = '/api/v1'

enum ApiPathname {
  APPOINTMENT_SCORINGS = '/appointment-scorings',
}

type GetAppointmentScoringsQuery = Query<{
  appointmentGid: string[]
  pageSize?: number
  status?: AppointmentScoringStatus[]
}>

interface UseHookContext {
  getAppointmentScorings: (query: GetAppointmentScoringsQuery) => Promise<GetAppointmentScoringsResponse>
}

const useSummaryService = (): UseHookContext => {
  const { url: baseUrl } = useServiceCountryUrl('summary')

  const getAppointmentScoringsRequest = useRequest<GetAppointmentScoringsQuery, GetAppointmentScoringsResponse>({
    baseUrl,
    filterQueryToSearchParams: identity,
    pathname: `${apiVersionSuffix}${ApiPathname.APPOINTMENT_SCORINGS}`,
    transformResponse: stripScoringPii,
  })

  const getAppointmentScorings = useCallback(
    (query: GetAppointmentScoringsQuery) =>
      getAppointmentScoringsRequest({ ...{ sort: 'DESC', sortBy: 'createdAt' }, ...query }),
    [getAppointmentScoringsRequest]
  )

  return { getAppointmentScorings }
}

export { PAYMENT_NOT_ASSESSABLE, SCORING_CATEGORY_MAX, SCORING_CATEGORY_ORDER, useSummaryService }
export type { AppointmentScoringRecord, AppointmentScoringStatus, GetAppointmentScoringsQuery, ScoringCategoryKey }
